// extracted by mini-css-extract-plugin
export default {"Box":"BlobTopBanners-module__Box--g_bGk"};